import { IonCardContent, IonIcon, IonLabel, IonSpinner, IonText, useIonToast } from '@ionic/react';
import { phonePortraitOutline, timerOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import ActionButton from '../../../../../components/button/ActionButton';
import InputItem from '../../../../../components/input/InputItem';
import { DataProvider } from '../../../../../library/DataProvider';
import { ActivationAccountPostAction, SendActivationPostAction } from '../../../../../redux/actions/Account';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';

import './Activation.css';

interface Props {
    uid: string,
    remainTime: number,
    loginSuccess: any,
    activationDone: any
}

const Activation: React.FC<Props> = (props) => {
    const [toast, dismiss] = useIonToast();

    const dispatch = useAppDispatch()
    const formActivation = useAppSelector(state => state.activation)
    const { form_loading, resp } = formActivation

    const formSendActivationCode = useAppSelector(state => state.sendActivation)
    const { form_loading2, resp2 } = formSendActivationCode

    const [showMin, setShowMin] = useState(props.remainTime > 60);
    const [remained, setRemained] = useState(props.remainTime);
    const [timer, setTimer] = useState({ minute: "0", second: "0" })
    const [submit, setSubmit] = useState(false);
    const [submit2, setSubmit2] = useState(false);

    const [form, setForm] = useState({
        activation_code: { value: "", validation: { required: true }, error: "" }
    });

    const [formProvider] = useState(() => new DataProvider(form, setForm));

    const formSubmitHandler = (e: any) => {
        e.preventDefault();

        let formValidation = formProvider.validation(form);

        if (formValidation) {
            setSubmit(true)

            dispatch(ActivationAccountPostAction(props.uid, form.activation_code.value))
        }
    }

    const sendActivationSMSHandler = () => {
        setSubmit2(true);

        dispatch(SendActivationPostAction(props.uid))
    }

    useEffect(() => {
        const formDone = () => {
            if (resp != null && !form_loading && submit) {
                if (resp.result) {
                    toast({ message: resp.message, duration: 2000, color: "primary" })
                    
                    formProvider.reset();

                    doRespDone();
                } else {
                    toast({ message: resp.message, duration: 2000, color: "danger" })
                }
            }
        }

        formDone();
    }, [form_loading])

    useEffect(() => {
        const formDone = () => {
            if (resp2 != null && !form_loading2 && submit2) {
                if (resp2.result) {
                    setRemained(resp2.remained)
                }
            }
        }

        formDone();
    }, [form_loading2])

    useEffect(() => {
        const iniTimer = () => {
            const setTimerToElements = (remainTime: any) => {
                min = Math.floor(remainTime / 60);
                sec = Math.floor(remainTime - (min * 60));

                setTimer({
                    minute: min.toString().length == 1 ? "0" + min.toString() : min.toString(),
                    second: sec.toString().length == 1 ? "0" + sec.toString() : sec.toString()
                });
            }

            let remainTime = remained;
            let min = 0;
            let sec = 0;

            setTimerToElements(remainTime);

            if (remainTime == 0) return;

            setShowMin(remainTime > 60);

            const timerFunc = setInterval(() => {
                remainTime -= 1
                setTimerToElements(remainTime)

                if (remainTime <= 0) {
                    clearInterval(timerFunc);
                    setRemained(0);
                }
            }, 1000);
        }

        iniTimer();
    }, [props.uid, remained])

    const doRespDone = async () => {
        setSubmit(false)

        props.activationDone();
        props.loginSuccess(resp.profile, resp.access_token, resp.refresh_token);
    }

    return <IonCardContent>
        <div className="activation">
            <form onSubmit={formSubmitHandler}>
                <div className="ion-margin-bottom">
                    <IonText>لطفا کد ارسال شده به تلفن همراه خود را وارد کنید.</IonText>
                </div>

                <InputItem name="activation_code" type="tel" label="کد فعال سازی" ltr spaced icon={phonePortraitOutline} maxlength={5} provider={formProvider} />

                <div className="ion-text-center ion-margin-bottom">
                    {remained == 0 ?
                        <Link className="send-sms-link" to="#" onClick={sendActivationSMSHandler}>
                            {form_loading2 ? <IonSpinner className="send-activation-spinner"></IonSpinner> : <IonText>ارسال مجدد کد فعال سازی</IonText>}
                        </Link>
                        :
                        <div className="timer">
                            <div className="number-section">
                                {showMin ? <IonText className="minute">{timer.minute}</IonText> : null}
                                {showMin ? <IonText className="sep">:</IonText> : null}
                                <IonText className="second">{timer.second}</IonText>
                            </div>
                            <div className="label-section">
                                <IonIcon icon={timerOutline} /> <IonLabel>زمان باقیمانده تا ارسال مجدد</IonLabel>
                            </div>
                        </div>}
                </div>

                <ActionButton text="فعال سازی حساب" loading={form_loading} />
            </form>
        </div>
    </IonCardContent>
}
export default Activation